export default __webpack_public_path__ + "static/media/music.4daaee9f.svg";